/** @fileoverview Shares the active tenant with app renderer components. */

import { createContext, useContext } from 'react';

const FabrikTenantContext = createContext('');

export const FabrikTenantProvider = FabrikTenantContext.Provider;

/** Returns the tenant id supplied by the nearest renderer root. */
export const useTenantId = () => useContext(FabrikTenantContext);
